export const Carfax = {
  name:'CarfaxComponent',    
  template://html
  `
      <div v-if="accountnumber" class="w-full flex justify-center my-2 carfax-accountnumber  srp-hook-carproof-section">
      <div v-html="this.badges"></div>
      </div>      
      <div v-else-if="thirdpartykey" class="w-full flex my-2 carfax-thirdpartykey srp-hook-carproof-section">
          <div class="carproof-badge" :data-vin="vin" :data-thirdpartykey="thirdpartykey" :data-language="language"></div>
          <script id="carproof-badge-js" type="application/javascript" src="https://badging.carproof.com/Scripts/CarProofBadges.min.js" :data-thirdpartykey="thirdpartykey" :data-language="language">
          </script>
      </div>

  `,
  props: {
      language: String,
      vin: String,
      accountnumber: String,
      thirdpartykey: String,
      webservicetoken: String
  },    
  data(){
      return {
          badges: ""
      }
    },
  created() {
      if(this.accountnumber && this.accountnumber !== "")
          this.getCarfax();
  },
  methods:{
      getCarfax (){
        let params = { "vin" : this.vin, "account" : this.accountnumber, "webservicetoken" : this.webservicetoken};
        wp.ajax.post("get_leadbox_carfax_from_api", { 'params': params })
          .done((response) => {
            this.badges = JSON.parse(response);
          })
          .fail(() => {
            this.badges = JSON.parse("");
          });
      },
      formatLang (language) {
        if(language == 'fr_CA'){
          return 'FR'
        }       
        else{
          return 'EN'
        }   
      }
    }
}